import { Component, OnInit, HostListener } from '@angular/core';
import { CWSMSAPIService } from '../cwsmsapi.service';
import { MatTabChangeEvent, MatIconRegistry } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
declare var Prism: any;

@Component({
  selector: 'app-api',
  templateUrl: './api.component.html',
  styleUrls: ['./api.component.css']
})
export class ApiComponent implements OnInit {

	keys: any = [];
	loading: boolean = false;
	defaultAPIKey: string = "";
	newAPIKeyName: string = "";
	sidemenuOpen: boolean = true;

	screenHeight: number;
	screenWidth: number;

	infoMessage: string = "";
	infoMessageHeight: string = "0";

	webhookEnabled: boolean = false;

	saveWebhookButtonText: string = "Save and enable";
	testOutput: string = "";
	testOutputBgColor: string = "#eee";

	webhookData: any = {
		url: "",
		method: "POST",
		authType: "none"
	};

	testWebhookData: any = {
		logid: "123a456b-789c-10d1-e120-1314151617ff",
		status: "DELIVERED"
	};

	constructor(public iconRegistry: MatIconRegistry, public cwsms: CWSMSAPIService, sanitizer: DomSanitizer, public translate: TranslateService) {
		iconRegistry.addSvgIcon('remove',sanitizer.bypassSecurityTrustResourceUrl('assets/img/remove.svg'));
		this.onResize();
	}

	@HostListener('window:resize', ['$event'])
	onResize(event?) {
		this.screenHeight = window.innerHeight;
		this.screenWidth = window.innerWidth;
		console.log(this.screenWidth+"x"+this.screenHeight);

		if (this.screenWidth < 720) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	copyKey(key) {
		var copyText: any = document.getElementById(key.APIKey);
		copyText.select();
		document.execCommand("copy");
		this.infoMessageHeight = "30px";
		this.infoMessage = "API key copied to clipboard!";
		setTimeout(() => {
			this.infoMessage = "";
			this.infoMessageHeight = "0px";
		}, 3000);
	}

	toggleSidemenu() {
		if (this.sidemenuOpen) {
			this.sidemenuOpen = false;
		} else {
			this.sidemenuOpen = true;
		}
	}

	removeKey(key) {
		if (confirm(this.translate.instant('Are you sure you wish to delete the API key named')+' "'+key.label+'"?')) {
			this.loading = true;
			this.cwsms.post('/user/api/key/delete', {
				APIKey: key.APIKey
			}, (err, data) => {
				if (err) {
					this.loading = false;
					console.log(err);
				} else {
					this.getAPIKeys();
				}
			});
		}
	}

	updateExampleAPIKey(elementID) {
		document.getElementById(elementID).innerHTML = document.getElementById(elementID).innerHTML.replace("%apikey%", this.defaultAPIKey);
		Prism.highlightElement(document.getElementById(elementID));
		//hljs.highlightBlock(document.getElementById(elementID));
	}

	ngOnInit() {
		this.getAPIKeys();
	}

	getAPIKeys() {
		this.loading = true;
		this.cwsms.get('/user/api/keys', (err, data) => {
			if (err) {
				this.loading = false;
				console.log(err);
			} else {
				console.log(data);
				this.keys = data.keys;
				if (this.keys.length > 0) {
					this.defaultAPIKey = this.keys[0].APIKey;
				}

				this.getWebhooks();

				this.updateExampleAPIKey("exampleCode_curl");
			}
		});
	}

	createAPIKey() {
		this.loading = true;
		this.cwsms.post('/user/api/key', {
			label: this.newAPIKeyName
		}, (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
			} else {
				this.newAPIKeyName = "";
				console.log(data);
				this.keys.push(data.key);
			}
		});
	}

	onExampleCodeTabChange(event: MatTabChangeEvent) {
		if (event.tab.textLabel == "Node.js") {
			this.updateExampleAPIKey("exampleCode_nodejs");
		} else if (event.tab.textLabel == "Python") {
			this.updateExampleAPIKey("exampleCode_python");
		} else if (event.tab.textLabel == "Java") {
			this.updateExampleAPIKey("exampleCode_java");
		} else if (event.tab.textLabel == "PHP (cURL)") {
			this.updateExampleAPIKey("exampleCode_PHP");
		} else if (event.tab.textLabel == "PHP (Guzzle)") {
			this.updateExampleAPIKey("exampleCode_PHP_guzzle");
		} else if (event.tab.textLabel == "C#") {
			this.updateExampleAPIKey("exampleCode_csharp");
		}
	}

	getWebhooks() {
		this.loading = true;
		this.cwsms.get('/user/api/webhooks', (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
			} else {
				console.log(data);
				for (var webhook of data.webhooks) {
					if (webhook.webhookid === "default") {
						this.saveWebhookButtonText = "Save";
						this.webhookData = webhook;
						this.webhookEnabled = true;

						if (!("authType" in webhook)) {
							this.webhookData.authType = "none";
						}
						break;
					}
				}
			}
		});
	}

	httpMethodChange() {
	}

	toggleWebhookEnabled() {
		this.webhookEnabled = !this.webhookEnabled;
	}

	testOutputScroll() {
		setTimeout( () => {
			var textarea = document.getElementById('test-output');
			textarea.scrollTop = textarea.scrollHeight;
		}, 100);
	}

	testWebhook() {
		var errorBackground = "repeating-linear-gradient(-45deg, #ffdddd, #ffdddd 10px, #fff 10px, #fff 20px)";
		var successBackground = "#ddffdd";
		if (this.webhookData.url.length <= 1) {
			this.testOutputBgColor = errorBackground;
			this.testOutput = "Webhook failed, not a valid URL.";
			return;
		}

		this.testOutputBgColor = "#eee";

		var exampleGET = "";

		if (this.webhookData.method === "GET") {
			exampleGET = "?logid="+this.testWebhookData.logid+"&status="+this.testWebhookData.status;
		}

		this.testOutput = this.webhookData.method+" "+this.webhookData.url+exampleGET+"\n";

		if (this.webhookData.method === "POST") {
			this.testOutput += "Body:\n"+JSON.stringify(this.testWebhookData, null, 2)+"\n\n";
		} else {
			this.testOutput += "\n";
		}

		var adjustedWebhookData = this.webhookData;
		adjustedWebhookData["logid"] = this.testWebhookData.logid;
		adjustedWebhookData["status"] = this.testWebhookData.status;

		this.loading = true;
		this.cwsms.post('/user/api/webhook/test', adjustedWebhookData, (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
				this.testOutput += "Failed to connect to host: "+err.error.code+"\n";
				this.testOutputBgColor = errorBackground;
			} else {
				console.log(data);
				this.testOutput += "Successfully connected to host.\n";
				if (data.success) {
					this.testOutputBgColor = successBackground;
					this.testOutput += "Webhook succeeded, ";
				} else {
					this.testOutputBgColor = errorBackground;
					this.testOutput += "Webhook failed, ";
				}
				this.testOutput += "HTTP response code: "+data.statusCode;
			}
			this.testOutputScroll();
		});
	}

	saveWebhook() {
		this.testOutput = "";
		this.loading = true;
		this.cwsms.post('/user/api/webhook', this.webhookData, (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
			} else {
				console.log(data);
				this.webhookEnabled = true;
			}
		});
	}

	deleteWebhook() {
		this.testOutput = "";
		this.loading = true;
		this.cwsms.delete('/user/api/webhook', (err, data) => {
			this.loading = false;
			if (err) {
				console.log(err);
			} else {
				console.log(data);
				this.webhookData = {
					url: "",
					method: "POST",
					authType: "none"
				};
				this.webhookEnabled = false;
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/api/api.component.ts